module.exports = __webpack_public_path__ + "static/media/citysearch.f04463df.png";